import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetsService, SponsorAssetText } from '../../infrastructure/services/assets.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { Location } from '@angular/common';
import { Translator } from 'angular-translator';

@Component({
  templateUrl: 'detalle.assetText.component.html'
})
export class DetalleAssetTextComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codSponsor: string;
  codProducto: string;
  idAsset: string;
  codAsset: string;
  esNuevo: boolean;
  esNuevoAsset: boolean;
  asset: SponsorAssetText;
  
  errores = {
    assetContent: null,
    codAsset: null,
  };

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private assetsService: AssetsService,
              private translator: Translator,
              private location: Location,
              public loader: LoaderService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codSponsor = null;
      this.codProducto = params['codproducto'];
      this.idAsset = params['idAsset'];
      this.codAsset = params['codAsset'];

      this.esNuevo = false;
      this.esNuevoAsset = false;

      if (this.codAsset === 'nuevo') {
        this.codAsset = '';
        this.esNuevoAsset = true;
      }

      // Si estoy creando un nuevo Asset
      if (this.idAsset === 'nuevo' ) {
        this.esNuevo = true;

        this.asset = {
          codAsset: this.codAsset,
          assetContent: '',
          codInstalacionV5: this.codSistema,
          codNegocio: this.codNegocio,
          codSponsor: this.codSponsor,
          codProducto: this.codProducto,
          descripcion: '',
        };
        return;
      }

      // Si estoy editando un asset existente
      this.assetsService
        .getAssetTextById(this.codSistema, this.codNegocio, this.codSponsor, this.idAsset)
          .then(res => this.asset = res);
    });
  }

  guardar() {
    if (this.datosValidos()) {
      this.assetsService.crearAssetText(this.asset)
        .then(this.volverAlListado.bind(this));
    }
  }

  editar() {
    if (this.datosValidos()) {
      this.assetsService.editarAssetText(this.idAsset, this.asset)
        .then(this.volverAlListado.bind(this));
    }
  }

  private datosValidos() {
    let esValido = true;

    // reseteo los errores antes de checkear nuevamente
    this.resetearErrores();

    if (this.asset.assetContent === null || this.asset.assetContent.length <= 0) {
        this.errores['assetContent'] = <string>this.translator.instant('VALOR_REQUERIDO');
        esValido = false;
    }

    if (this.asset.codAsset === null || this.asset.codAsset.length <= 0) {
        this.errores['codAsset'] = <string>this.translator.instant('VALOR_REQUERIDO');
        esValido = false;
    }

    return esValido;
  }

  private resetearErrores() {
    Object.keys(this.errores).forEach(key => this.errores[key] = null);
  }

  private volverAlListado() {
    this.router.navigate(['../../../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/assets/detalle.assetText.component.ts